import { useEffect } from 'react';

type UseGlobalKeyDownOptions = {
  // When provided, attaches the listener to this element instead of window,
  // enabling a scoped boundary below a stopPropagation wrapper.
  targetRef?: { current: EventTarget | null };
};

export const useGlobalKeyDown = (handler: (event: Event) => void, { targetRef }: UseGlobalKeyDownOptions = {}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const targetEl = targetRef?.current;

  useEffect(() => {
    const target = targetEl ?? global.window;
    target.addEventListener('keydown', handler);
    return () => {
      target.removeEventListener('keydown', handler);
    };
  }, [handler, targetEl]);
};
